// src/services/CountryService.js
import api from "./api";

export function userUpload(data) {
    return api.post("/userdocuments/uploaddocument", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

export function getUserDocuments() {
    return api.get(`/userdocuments/userdocuments`);
}

export function getCities(page = 1, limit = 10, country_id) {
    return api.get(
        `/jobs/getcitydropdown?page=${page}&limit=${limit}&country_id=${country_id}`
    );
}
